let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("btO74")).then(() => parcelRequire('dnjEm'));